<template>
  <h4>Major Sponsor</h4>
  <div>
    <a href="https://www.embo.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embo.png"
        alt="EMBO"
        title="EMBO" />
      <img v-else src="./img/embo-darkMode.png" alt="EMBO" title="EMBO" />
    </a>
  </div>
  <h4>Silver Sponsors</h4>
  <div>
    <a href="http://www.autodesk.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk" />
      <img v-else src="./img/Autodesk-darkMode.png" alt="Autodesk" title="Autodesk" />
    </a>
  </div>
  <h4>Bronze Sponsors</h4>
  <div>
    <a href="http://www.amira.com/" rel="nofollow">
      <img src="./img/amira.jpg" alt="amira" title="amira" />
    </a>
    <a href="http://www.bitplane.com/" rel="nofollow">
      <img src="./img/bitplane.jpg" alt="bitplane" title="bitplane" />
    </a>
    <a href="http://www.nvidia.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/nvidia.svg" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/NVIDIA-darkMode.svg" alt="NVIDIA" title="NVIDIA" />
    </a>
  </div>
  <h4>General Sponsors</h4>
  <div>
    <a href="http://www.embl.de/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embl.png"
        alt="EMBL"
        title="EMBL" />
      <img v-else src="./img/embl-darkMode.png" alt="EMBL" title="EMBL" />
    </a>
    <a href="http://www.biomedcentral.com/" rel="nofollow">
      <img src="./img/BMC.jpg" alt="BMC" title="BMC" />
    </a>
    <a href="http://rsob.royalsocietypublishing.org/" rel="nofollow">
      <img src="./img/rsob_open_biology.jpg" alt="Open Biology" title="Open Biology" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <p>
    If you are interested in contributing to the VIZBI conference as a sponsor, please see the
    <a href="/2012/VIZBI_2012_Sponsorship_Brochure.pdf">VIZBI 2012 Sponsorship Brochure</a> for
    general information and pricing, or see
    <a href="http://www.embl.de/training/events/sponsorship/index.html"
    >EMBL&rsquo;s conference sponsorship page</a
    >.
  </p>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>
